// Shared accordion styles for sidebar components
export const accordionItemStyles = {
  item: "my-1 flex min-h-fit w-full flex-col items-start justify-start overflow-hidden border-none py-1",
  trigger:
    "w-full px-2 pt-0 pb-1 text-xs text-zinc-600 font-normal hover:no-underline hover:text-zinc-600",
  content: "w-full p-0!",
  chatContainer: "flex w-full flex-col gap-1",
};
